var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 31.25,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1503_2610)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1503_2610)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6247 41.4584C87.7497 43.3334 91.6663 45.8334 91.6663 50C91.6663 54.1667 87.7497 56.6667 84.6247 58.2084C83.6543 58.7567 82.7218 59.3692 81.833 60.0417C82.1451 61.17 82.5493 62.2713 83.0413 63.3334C83.0768 63.4196 83.1126 63.5063 83.1488 63.5938C84.5063 66.8775 86.1434 70.8384 83.708 74.1667C81.208 77.5834 76.7497 77.2084 73.1247 76.875C71.9734 76.7942 70.8176 76.7942 69.6663 76.875C69.398 77.5646 69.0597 78.9234 68.8126 79.915C68.7909 80.0021 68.7697 80.0863 68.7497 80.1667C68.7359 80.2288 68.7218 80.2909 68.708 80.3534C67.9251 83.8621 66.9684 88.1475 62.8747 89.4167C62.2422 89.625 61.5822 89.7375 60.9163 89.75C57.8351 89.3321 54.9934 87.8596 52.8747 85.5834C51.9726 84.7642 51.0118 84.0121 49.9997 83.3334C48.9876 84.0121 48.0268 84.7642 47.1247 85.5834C44.4163 88.125 41.1663 91.0417 37.1247 89.75C33.083 88.4584 32.0413 84.0417 31.2497 80.5C31.2295 80.4196 31.2086 80.3354 31.1869 80.2484C30.9398 79.2567 30.6012 77.898 30.333 77.2084C29.1817 77.1275 28.026 77.1275 26.8747 77.2084C23.2497 77.5417 18.7497 77.875 16.2913 74.5C13.8631 71.1663 15.5408 67.1009 16.9074 63.7896L16.958 63.6667C17.4503 62.6046 17.8544 61.5034 18.1663 60.375C17.2777 59.7025 16.345 59.09 15.3747 58.5417C12.2497 56.6667 8.33301 54.1667 8.33301 50C8.33301 45.8334 12.2497 43.3334 15.3747 41.5834C16.345 41.0352 17.2777 40.4227 18.1663 39.75C17.8544 38.6216 17.4503 37.5207 16.958 36.4584C16.9224 36.3721 16.8866 36.2854 16.8505 36.1982C15.4932 32.9142 13.856 28.9533 16.2913 25.625C18.7913 22.2084 23.2497 22.5834 26.8747 22.9167C28.026 22.9978 29.1817 22.9978 30.333 22.9167C30.6012 22.2271 30.9398 20.8683 31.1869 19.8765C31.2086 19.7897 31.2295 19.7056 31.2497 19.625C32.0413 16.0834 33.208 11.75 37.1247 10.4584C41.0338 9.16921 44.4034 12.0723 47.1093 14.4033L47.1247 14.4167C48.0268 15.2358 48.9876 15.9878 49.9997 16.6667C51.0188 15.921 51.9797 15.0993 52.8747 14.2084C52.9376 14.1543 53.0005 14.0998 53.0638 14.0452C55.7343 11.742 58.9268 8.98834 62.8747 10.25C66.9163 11.5417 67.958 15.9584 68.7497 19.5C68.7697 19.5806 68.7909 19.6647 68.8126 19.7516C69.0597 20.7433 69.398 22.1021 69.6663 22.7917C70.8176 22.8727 71.9734 22.8727 73.1247 22.7917C76.7497 22.4584 81.2497 22.125 83.708 25.5C86.1363 28.8337 84.4584 32.8992 83.0922 36.2107L83.0413 36.3334C82.5493 37.3957 82.1451 38.4966 81.833 39.625C82.7218 40.2977 83.6543 40.9102 84.6247 41.4584ZM49.083 63L65.7497 42.1667C66.9476 40.3644 66.5663 37.945 64.8722 36.5984C63.1784 35.2518 60.7351 35.4263 59.2497 37L45.4997 54.1667L40.458 49.125C38.8242 47.4913 36.1752 47.4913 34.5413 49.125C32.9075 50.7588 32.9075 53.408 34.5413 55.0417L42.8747 63.375C43.6609 64.155 44.7255 64.5896 45.833 64.5834H46.083C47.2622 64.505 48.353 63.9296 49.083 63Z",
    fill: "#1BAE21"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1503_2610",
    x: 0.333008,
    y: 5.93262,
    width: 99.333,
    height: 96.1338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1503_2610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1503_2610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1503_2610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyImg);
export default __webpack_public_path__ + "static/media/verifyImg.931b36bcc0e0d7abc4c31f26938b4272.svg";
export { ForwardRef as ReactComponent };